var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "employeeDetailsValidation",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          var validate = ref.validate
          return [
            _c(
              "b-form",
              {
                staticClass: "mt-2",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Department*",
                              "label-for": "department",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "department" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            disabled: !_vm.isEdit,
                                            options: _vm.departmentOptions,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value:
                                              _vm.employementDetail
                                                .departmentId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employementDetail,
                                                "departmentId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employementDetail.departmentId",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Designation*",
                              "label-for": "designation",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "designation" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            disabled: !_vm.isEdit,
                                            options: _vm.designationOptions,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value:
                                              _vm.employementDetail
                                                .designationId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employementDetail,
                                                "designationId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employementDetail.designationId",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Hire Date*",
                              "label-for": "hireDate",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "Hire Date" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("DatePicker", {
                                          attrs: {
                                            type: "date",
                                            format: "YYYY-MM-DD",
                                            "value-type": "YYYY-MM-DD",
                                            placeholder: "Select Hire Date",
                                            clearable: false,
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            "default-value": null,
                                            editable: false,
                                            "disabled-date":
                                              _vm.disableFutureDates,
                                          },
                                          model: {
                                            value:
                                              _vm.employementDetail.hireDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employementDetail,
                                                "hireDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employementDetail.hireDate",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Reporting Person",
                              "label-for": "reportingPerson",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "reporting person" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            disabled: !_vm.isEdit,
                                            options: _vm.managerOptions,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value:
                                              _vm.employementDetail.managerId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employementDetail,
                                                "managerId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employementDetail.managerId",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Status",
                              "label-for": "employmentstatus",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "status" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "employmentstatus",
                                            options: _vm.employementStatus,
                                            disabled: !_vm.isEdit,
                                            state:
                                              errors.length > 0 ? false : null,
                                            required: "",
                                          },
                                          model: {
                                            value:
                                              _vm.employementDetail
                                                .employmentStatus,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employementDetail,
                                                "employmentStatus",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employementDetail.employmentStatus",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { sm: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Employee Type*",
                              "label-for": "employeeType",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "type" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "employeeType",
                                            options: _vm.optionemployeeType,
                                            disabled: !_vm.isEdit,
                                            required: "",
                                          },
                                          model: {
                                            value:
                                              _vm.employementDetail
                                                .employeeType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.employementDetail,
                                                "employeeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "employementDetail.employeeType",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }